const getBasePlaceholder = (entity: string): string => {
  return `Search by ${entity} name`;
};

export const getAssignmentsPageSearchPlaceholder = (isProvider: boolean): string => {
  const entity = isProvider ? 'facility' : 'provider';
  return getBasePlaceholder(entity);
};

export const getConnectionsPageSearchPlaceholder = (isProvider: boolean): string => {
  const entityName = isProvider ? 'organization' : 'provider';
  return getBasePlaceholder(entityName);
};
